import { FacetModel } from "@crescentParts/Components/Training/TrainingFiltersAccordionSection";
import CustomApplicationState from "@crescentParts/Store/CustomApplicationState";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

interface CrescentTrainingFiltersState {
    filteredTrainings: any[];
    typeFilters: FacetModel[];
    locationFilters: FacetModel[];
    priceFilters: FacetModel[];
    peuFilters: FacetModel[];
    restrictionFilters: FacetModel[];
    appliedFilters: any[];
    selectedFilterNamesArr: string[];
}
const initialState: CrescentTrainingFiltersState = {
    filteredTrainings: [],
    typeFilters: [],
    locationFilters: [],
    priceFilters: [],
    peuFilters: [],
    restrictionFilters: [],
    appliedFilters: [],
    selectedFilterNamesArr: [], // Contains all selected filter names(used for updating filter selection)
};

const reducer = createTypedReducerWithImmer(initialState, {
    "CrescentPartsTraining/GenerateDynamicFilters": (
        draft: Draft<CrescentTrainingFiltersState>,
        action: { payload: any },
    ) => {
        draft.typeFilters = action.payload.typeFilters;
        draft.locationFilters = action.payload.locationFilters;
        draft.priceFilters = action.payload.priceFilters;
        draft.peuFilters = action.payload.peuFilters;
        draft.restrictionFilters = action.payload.restrictionFilters;
    },
    "CrescentPartsTraining/ApplyFiltersFromUrl": (
        draft: Draft<CrescentTrainingFiltersState>,
        action: { payload: any },
    ) => {
        draft.appliedFilters = action.payload.appliedFilters;
        draft.selectedFilterNamesArr = action.payload.selectedFilterNamesArr;
        draft.filteredTrainings = action.payload.filteredTrainings;
    },
});

(reducers as any).customCrescentPartsTraining = reducer;

export type CustomCrescentPartsTrainingState = {
    customCrescentPartsTraining: CrescentTrainingFiltersState;
} & CustomApplicationState;

type Reducers = {
    customCrescentPartsTrainingReducer: typeof reducer;
};

export type CustomCrescentPartsTrainingActions = Parameters<Reducers[keyof Reducers]>[1] | AnyAction;
